export default __webpack_public_path__ + "static/filter-button-metric-do-light-65be3ef18c95e9abdfe14d9107a04fed.png";